module.exports = __webpack_public_path__ + "h5/img/writeOff.e1bf8d03.jpg";